import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { IssueService } from '../../../services/issue.service';
import { ClaimsService } from '../../../services/claims.service';


enum featureEnum {

    payg = 'payg',
    billing = 'billing',
    metering = 'metering'
}

@Component({
    selector: 'summary-summary-grid-item',
    templateUrl: './summary-summary-grid-item.component.html'
})
export class SummarySummaryGridItemComponent implements AfterViewInit, OnDestroy {

    clientId: number;
    numberOfConsumerWithIssues: number;
    numberOfIssues: number;
    issuesLastMonth: number;
    issuesVariation: number = 0;
    subscriptions: any[] = [];
    promiseArray: {
        key: featureEnum,
        value: Promise<any>
    }[] =[];
    isDecreasing: boolean = false;
    isIncreasing: boolean = false;
    isSuperUser: boolean = false;
    isPayg: boolean = false;
    isBilling: boolean = false;
    isConsumption: boolean = false;
    hasLoaded: boolean = false;

    constructor(
        private claimsService: ClaimsService,
        private issueService: IssueService,
        private route: ActivatedRoute,
        private router: Router
    ) { }

    ngAfterViewInit() {
        this.subscriptions.push(this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        }));
    }

    onInitialise() {
        this.clientId = this.route.parent.parent.snapshot.params['clientId'];

        try {
            this.isSuperUser = this.claimsService.isSuperUser();
            this.isPayg = this.claimsService.hasPaygFeature();
            this.isBilling = this.claimsService.hasBillingFeature();
            this.isConsumption = this.claimsService.hasConsumptionFeature();
        } catch { }

        let billingSummaryPromise = this.issueService.billingSummary(this.clientId);
        let paygSummaryPromise = this.issueService.paygSummary(this.clientId);
        let consumptionSummaryPromise = this.issueService.getConsumptionSummary(this.clientId);

        if (this.isPayg) { this.promiseArray.push({ key: featureEnum.payg, value: paygSummaryPromise }); }
        if (this.isBilling) { this.promiseArray.push({ key: featureEnum.billing, value: billingSummaryPromise }); }
        if (this.isConsumption) { this.promiseArray.push({ key: featureEnum.metering, value: consumptionSummaryPromise }); }

        Promise.all(this.promiseArray.map(x => x.value)).then(
            (result: any) => {

                this.numberOfIssues = 0;
                this.numberOfConsumerWithIssues = 0;
                this.issuesLastMonth = 0;

                for (let i = 0; i < this.promiseArray.length; i++) {

                    if (this.promiseArray[i].key == featureEnum.payg) {
                        this.issuesLastMonth += result[i].paygIssuesLastMonth
                    }

                    if (this.promiseArray[i].key == featureEnum.billing) {
                        this.issuesLastMonth += result[i].billingIssuesLastMonth
                    }

                    if (this.promiseArray[i].key == featureEnum.metering) {
                        this.issuesLastMonth += result[i].mtrIssuesLastMonth
                    }

                    this.numberOfIssues += result[i].numberOfIssues;
                    this.numberOfConsumerWithIssues = result[i].numberofConsumersExperiencingIssues;
                }

                this.issuesVariation = this.numberOfIssues - this.issuesLastMonth;
                this.isIncreasing = this.issuesLastMonth < this.numberOfIssues ? true : false;
                this.isDecreasing = this.issuesLastMonth > this.numberOfIssues ? true : false;

            },
            error => {

                this.numberOfIssues = 0;
                this.issuesLastMonth = 0;
                this.issuesVariation = 0;

                if (this.isBilling || this.isSuperUser) {
                    this.issueService.billingSummary(this.clientId).then((billResult) => {
                        this.numberOfConsumerWithIssues = billResult.numberofConsumersExperiencingIssues;
                        this.issuesLastMonth = billResult.billingIssuesLastMonth;
                        this.numberOfIssues = billResult.numberOfIssues;
                        this.issuesVariation = this.numberOfIssues - this.issuesLastMonth;
                        this.isIncreasing = this.issuesLastMonth < this.numberOfIssues ? true : false;
                        this.isDecreasing = this.issuesLastMonth > this.numberOfIssues ? true : false;

                    });
                }

                if (this.isPayg || this.isSuperUser) {
                    this.issueService.paygSummary(this.clientId).then((paygResult) => {
                        this.numberOfConsumerWithIssues = paygResult.numberofConsumersExperiencingIssues;
                        this.issuesLastMonth = paygResult.paygIssuesLastMonth;
                        this.numberOfIssues = paygResult.numberOfIssues;
                        this.issuesVariation = this.numberOfIssues - this.issuesLastMonth;
                        this.isIncreasing = this.issuesLastMonth < this.numberOfIssues ? true : false;
                        this.isDecreasing = this.issuesLastMonth > this.numberOfIssues ? true : false;
                    });
                }

                if (this.isConsumption || this.isSuperUser) {
                    this.issueService.getConsumptionSummary(this.clientId).then((conResut) => {
                        this.numberOfConsumerWithIssues = conResut.numberofConsumersExperiencingIssues;
                        this.issuesLastMonth = conResut.mtrIssuesLastMonth;
                        this.numberOfIssues = conResut.numberOfIssues;
                        this.issuesVariation = this.numberOfIssues - this.issuesLastMonth;
                        this.isIncreasing = this.issuesLastMonth < this.numberOfIssues ? true : false;
                        this.isDecreasing = this.issuesLastMonth > this.numberOfIssues ? true : false;
                    });
                }

                
            }
        )
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    returnFromPromiseRoles(array: any[]): any {
        let returnPromiseArray = [];
        for (let i = 0; i < array.length; i++) {
            returnPromiseArray.push(array[i][2]);
        }

        return returnPromiseArray;
    }
}
